import ApplyJobsContainer from "../../../components/miscellaneous/jobSearch/applyJobs";

const JobApply = () => {
  return <ApplyJobsContainer />;
};

export default JobApply;
